import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import BoothJson from '../data/booths.json';

import { BoothItem, BoothModel } from '../models';


@Injectable({
    providedIn: 'root'
})
export class BoothService {
    public NUM_BOOTHS: number = 0;

    public boothModel: BoothModel;

    public boothDataUpdated = new BehaviorSubject(false);

    constructor() { }

    public setBoothDataChanged(bool: boolean): void {
        this.boothDataUpdated.next(bool);
    }

    public async setUpBoothData() {

        this.boothModel = BoothJson;
        console.log('this.boothModel', BoothJson);
        for (let i = 0; i < this.boothModel.booths.length; i++) {
            const booth: BoothItem = this.boothModel.booths[i];
            const name = booth.name.toLowerCase();
            const b = await import(`../data/booths/${name}.json`);
            this.boothModel.booths[i] = { ...b, ...booth };
            console.log('booth', booth);
        }
        console.log('this.boothModel', this.boothModel);
        this.NUM_BOOTHS = this.boothModel.booths.length;
        this.setBoothDataChanged(true);
    }




}
